var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaterialsResources(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_702",
    "data-name": "Group 702",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 12.7,
    height: 12.694,
    viewBox: "0 0 12.7 12.694",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_194",
    "data-name": "Rectangle 194",
    width: 12.7,
    height: 12.694,
    fill: "currentColor"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_701",
    "data-name": "Group 701",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_364",
    "data-name": "Path 364",
    d: "M12.7,286.41v.521h-.446L8.1,285.869a2,2,0,0,1-3.5,0l-4.15,1.062H.305a.4.4,0,0,1-.186-.67c.055-.049.14-.051.182-.116.147-.407.183-.932.333-1.328a.534.534,0,0,1,.1-.168,4.217,4.217,0,0,1,.665-.326c1.5-.638,3.434-1.056,4.942-.249,1.524-.8,3.43-.4,4.941.242a4.2,4.2,0,0,1,.683.334.533.533,0,0,1,.1.168c.151.4.186.92.333,1.328a.762.762,0,0,1,.293.265",
    transform: "translate(0 -274.237)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_365",
    "data-name": "Path 365",
    d: "M2.194.009A1.179,1.179,0,0,1,2.41,2.357,1.18,1.18,0,0,1,2.194.009",
    transform: "translate(-1.126 -0.001)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_366",
    "data-name": "Path 366",
    d: "M205.668,59.978a.386.386,0,0,1,.421.5l-1,4.159a.381.381,0,1,1-.726-.23l.992-4.165a.394.394,0,0,1,.31-.261",
    transform: "translate(-197.585 -57.987)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_367",
    "data-name": "Path 367",
    d: "M37.034,125.873a.437.437,0,0,1,.329.106l2.367,2.368a.386.386,0,0,1-.521.57l-2.38-2.379a.389.389,0,0,1,.2-.664",
    transform: "translate(-35.495 -121.701)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_368",
    "data-name": "Path 368",
    d: "M145.016,101.913a.392.392,0,0,1,.421.262c.083.9.338,1.855.4,2.748a.465.465,0,0,1-.137.452.389.389,0,0,1-.6-.189c-.083-.9-.338-1.855-.4-2.748-.017-.246.026-.482.313-.525",
    transform: "translate(-139.908 -98.535)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_369",
    "data-name": "Path 369",
    d: "M310,6.79c-.048-.328.032-.782.466-.677.334.081.279.406.277.677.373-.072.867.109.654.567a.43.43,0,0,1-.27.2h-.384c.023.286.022.683-.36.7s-.413-.406-.383-.7h-.384a.763.763,0,0,1-.211-.112.417.417,0,0,1,0-.545.763.763,0,0,1,.211-.112Z",
    transform: "translate(-299.061 -5.896)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_370",
    "data-name": "Path 370",
    d: "M243.029,167.77a.385.385,0,0,1,.287.685l-2.556,1.064a.385.385,0,0,1-.287-.685Z",
    transform: "translate(-232.368 -162.21)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_371",
    "data-name": "Path 371",
    d: "M227.792,248.174c.02-.04.107-.067.149-.086a7.137,7.137,0,0,1,3.553-.332c.316.047.666.063.637.481a.382.382,0,0,1-.386.336c-.181,0-.493-.078-.694-.1-.444-.051-.739-.108-1.172-.191a7.475,7.475,0,0,0-2.087-.107",
    transform: "translate(-220.248 -239.471)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_372",
    "data-name": "Path 372",
    d: "M29.085,248.042c.007.041-.06.027-.087.026a8.082,8.082,0,0,0-2,.105c-.432.083-.729.14-1.172.191-.2.023-.513.1-.694.1a.383.383,0,0,1-.143-.74,5.667,5.667,0,0,1,1.208-.155,6.616,6.616,0,0,1,2.889.472",
    transform: "translate(-23.921 -239.363)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_373",
    "data-name": "Path 373",
    d: "M180.911,36.007a.384.384,0,0,1,.09.762.384.384,0,0,1-.09-.762",
    transform: "translate(-174.613 -34.809)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_374",
    "data-name": "Path 374",
    d: "M282.713,101.879a.384.384,0,0,1,.09.762.384.384,0,0,1-.09-.762",
    transform: "translate(-273.043 -98.5)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_375",
    "data-name": "Path 375",
    d: "M7.251,191.7a.384.384,0,0,1,.09.762.384.384,0,0,1-.09-.762",
    transform: "translate(-6.704 -185.349)",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterialsResources);
export default __webpack_public_path__ + "static/media/MaterialsResources.4874e0ee7bcfbb1d74a9a93d2b00ac43.svg";
export { ForwardRef as ReactComponent };